import { useContent } from "@/context/ContentContext";
import RichText from "@/components/RichText";
import { openCookieSettings } from "@/components/CookieConsent";

export default function CookiePolicy() {
  const { t } = useContent();
  return (
    <div data-testid="cookie-policy-page">
      <section className="bg-ink-800 text-bone-50">
        <div className="section pt-24 pb-16 md:pt-32 md:pb-20">
          <div className="eyebrow !text-gold-400 mb-6">{t("cookie_policy.eyebrow", "Legal")}</div>
          <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight">
            {t("cookie_policy.title", "Cookie Policy")}
          </h1>
          <p className="mt-6 text-lg md:text-xl text-bone-100/80 leading-relaxed max-w-2xl font-light">
            {t("cookie_policy.subtitle")}
          </p>
          <div className="mt-8 text-xs uppercase tracking-[0.22em] text-gold-400">
            {t("cookie_policy.last_updated")}
          </div>
        </div>
      </section>

      <section className="section py-20 md:py-28 grid md:grid-cols-12 gap-12">
        <aside className="md:col-span-4">
          <div className="md:sticky md:top-32 border-t border-gold-500 pt-8">
            <div className="eyebrow mb-6">Manage your choices</div>
            <p className="text-ink-800/75 text-sm leading-relaxed">
              You can review or change your cookie consent at any time.
            </p>
            <button
              onClick={openCookieSettings}
              className="btn-outline-ink mt-6"
              data-testid="open-cookie-settings"
            >
              Cookie settings
            </button>
          </div>
        </aside>

        <article className="md:col-span-8 max-w-3xl">
          <RichText text={t("cookie_policy.body")} testId="cookie-policy-body" />
        </article>
      </section>
    </div>
  );
}
